
import ChevronDown from '@/assets/svg/icons/chevron-down.svg';
import Vue from 'vue';

export default Vue.extend({
  props: {
    id: { type: String, required: true },
    headline: { type: String, required: true },
    links: { type: Array },
    content: { type: [String, Array, Object] },
    contentType: {
      type: String,
    },
  },
  components: { ChevronDown },
  data() {
    return {
      isExpanded: false,
    };
  },
  methods: {
    toggleCollapsible() {
      this.isExpanded = !this.isExpanded;
    },
  },
});
